import gql from 'graphql-tag';
export const GET_TECHNICIAN_SERVICE_AREA = gql`
	query GetTechnicianServiceArea($id: String!) {
		user(id: $id) {
			id
			name
			serviceAreas
			regions {
				id
			}
		}
	}
`;

export const GET_TECHNICIAN_SERVICE_AREA_REGIONS = gql`
	query GetTechnicianServiceAreaRegions($query: JSON!) {
		regions(query: $query) {
			id
			name
			latitude
			longitude
			state
			zipCodes
			timezone
		}
	}
`;
